// InfoCard.tsx
import { PropsWithChildren, useState } from 'react';
import styled from 'styled-components';
import { Box } from '../atoms';
import { IconButton } from '../atoms/icons/Icon';
import { colors } from '../utils/colors';

const Wrapper = styled.div`
    position: relative;
    padding: 16px;
    background-color: ${colors.blue900};
    color: white;
    border-radius: 16px;
    max-width: 600px;

    animation: fadeSlideIn 300ms ease-out;

    &::before {
        content: '';
        position: absolute;
        top: -8px;
        right: 16px;
        width: 0;
        height: 0;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid ${colors.blue900};
    }
`;

export function InfoPopover({
    children,
    header,
    openDefaultValue,
}: PropsWithChildren<{
    header?: React.ReactNode;
    openDefaultValue?: boolean;
}>) {
    const [isOpen, setIsOpen] = useState(!!openDefaultValue);
    return (
        <Box gap="16" direction="column" width="100%" alignItems="flex-end">
            <Box
                width="100%"
                alignItems="center"
                justifyContent="space-between"
                wrap="nowrap"
            >
                {header}
                <Box
                    width="48px"
                    height="48px"
                    br="8"
                    justifyContent="center"
                    alignItems="center"
                >
                    <IconButton
                        variant={isOpen ? 'primary' : 'ghost'}
                        name="questionMark"
                        ariaLabel="More information"
                        onClick={() => setIsOpen(!isOpen)}
                    />
                </Box>
            </Box>
            {isOpen && <Wrapper>{children}</Wrapper>}
        </Box>
    );
}
